import { useStickyBarHeight } from '@bob/library'
import { useEffect } from 'react'

/**
 * Applies the total height of all sticky bars as `scroll-margin-top` on all heading elements.
 */
export const useStickyBarHeightScrollMargin = () => {
  const totalStickyHeight = useStickyBarHeight()

  // Apply total sticky bar height as total margin top on all heading elements
  // Enables us to scroll to the right spot so sticky bars don't overlap elements
  useEffect(() => {
    const headersWithId = document.querySelectorAll(
      'h1[id], h2[id], h3[id], h4[id], h5[id], h6[id]'
    )

    if (!headersWithId.length) {
      return
    }

    headersWithId.forEach((h) => {
      const headingElm = h as HTMLHeadingElement

      headingElm.style.scrollMarginTop = `${totalStickyHeight + 30}px`
    })
  }, [totalStickyHeight])

  // When unmounted remove the style again
  useEffect(() => {
    return () => {
      const headersWithId = document.querySelectorAll(
        'h1[id], h2[id], h3[id], h4[id], h5[id], h6[id]'
      )

      if (!headersWithId.length) {
        return
      }

      headersWithId.forEach((h) => {
        const headingElm = h as HTMLHeadingElement

        headingElm.style.scrollMarginTop = ''
      })
    }
  }, [])
}
